import { Phone, Mail, MapPin, ArrowUpRight } from "lucide-react";
import { ASSETS, COMPANY } from "../../data";
import { Reveal, MaskLineInView } from "./Reveal";

export const Contact = () => (
  <section
    id="contact"
    data-testid="contact-section"
    className="relative bg-[var(--ink)] text-white overflow-hidden pt-16 md:pt-36"
  >
    <div className="grain" />
    <div className="relative max-w-[1400px] mx-auto px-5 md:px-10">
      <span className="font-mono text-xs uppercase tracking-[0.25em] text-[#5b8cff]">
        Get in touch
      </span>
      <h2 className="font-display font-semibold tracking-tighter leading-[1.0] sm:leading-[0.92] mt-5 text-4xl sm:text-6xl md:text-8xl">
        <MaskLineInView>Let's mold</MaskLineInView>
        <MaskLineInView delay={0.08}>
          your <span className="text-[#5b8cff]">next batch.</span>
        </MaskLineInView>
      </h2>

      <div className="mt-10 md:mt-16 grid grid-cols-1 md:grid-cols-3 gap-px bg-white/10 border border-white/10 rounded-2xl overflow-hidden">
        <a
          data-testid="contact-phone"
          href={`tel:${COMPANY.phone1raw}`}
          className="group bg-[var(--ink-soft)] p-8 md:p-10 hover:bg-[#1a2650] transition-colors"
        >
          <Phone className="text-[#5b8cff]" size={22} />
          <span className="block font-mono text-[11px] uppercase tracking-[0.2em] text-slate-400 mt-6">
            Call
          </span>
          <span className="block font-display text-xl md:text-2xl font-medium mt-2 tracking-tight">
            {COMPANY.phone1}
          </span>
          <span className="block text-slate-400 mt-1">{COMPANY.phone2}</span>
        </a>

        <a
          data-testid="contact-email"
          href={`mailto:${COMPANY.email}`}
          className="group bg-[var(--ink-soft)] p-8 md:p-10 hover:bg-[#1a2650] transition-colors"
        >
          <Mail className="text-[#5b8cff]" size={22} />
          <span className="block font-mono text-[11px] uppercase tracking-[0.2em] text-slate-400 mt-6">
            Email
          </span>
          <span className="flex items-center gap-1 font-display text-lg md:text-xl font-medium mt-2 tracking-tight break-all">
            {COMPANY.email}
            <ArrowUpRight size={18} className="shrink-0 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
          </span>
          <span className="block text-slate-400 mt-2 text-sm">POC — {COMPANY.poc}</span>
        </a>

        <div data-testid="contact-address" className="bg-[var(--ink-soft)] p-8 md:p-10">
          <MapPin className="text-[#5b8cff]" size={22} />
          <span className="block font-mono text-[11px] uppercase tracking-[0.2em] text-slate-400 mt-6">
            Visit
          </span>
          <span className="block font-display text-lg font-medium mt-2 tracking-tight leading-snug">
            {COMPANY.address}
          </span>
        </div>
      </div>

      <div className="mt-4 rounded-2xl overflow-hidden border border-white/10 h-[320px] md:h-[420px]" data-testid="facility-map">
        <iframe
          title="Polycaps Tech Plast — Nagpur facility location"
          src="https://www.google.com/maps?q=Navkar%20Industrial%20Estate%20%26%20Logistics%20Park%2C%20Mahalgoan%2C%20Nagpur%20441104&output=embed"
          width="100%"
          height="100%"
          style={{ border: 0, filter: "grayscale(0.2) contrast(1.05)" }}
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          allowFullScreen
        />
      </div>
    </div>

    <footer className="relative mt-20 md:mt-28 border-t border-white/10">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-10 flex flex-col md:flex-row items-center justify-between gap-6">
        <img src={ASSETS.logo} alt="Polycaps" className="h-12 w-auto object-contain rounded-md" />
        <p className="text-sm text-slate-500 text-center">
          © {new Date().getFullYear()} {COMPANY.legal}. All rights reserved.
        </p>
        <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-slate-500">
          Nagpur · India
        </p>
      </div>
    </footer>
  </section>
);
